import './styles/HorizontalBar.css';

const HorizontalBar = () => (
  <div className="horizontal-bar" />
);

export default HorizontalBar;
